export const FETCH_TERMINALS_OF_ENTITY_REQUEST = '[CHART_CONFIG] FETCH_TERMINALS_OF_ENTITY_REQUEST';
export const FETCH_TERMINALS_OF_ENTITY_SUCCESS = '[CHART_CONFIG] FETCH_TERMINALS_OF_ENTITY_SUCCESS';
export const FETCH_TERMINALS_OF_ENTITY_FAILED = '[CHART_CONFIG] FETCH_TERMINALS_OF_ENTITY_FAILED';

export const FETCH_INTERFACES_OF_ENTITY_REQUEST = '[CHART_CONFIG] FETCH_INTERFACES_OF_ENTITY_REQUEST';
export const FETCH_INTERFACES_OF_ENTITY_SUCCESS = '[CHART_CONFIG] FETCH_INTERFACES_OF_ENTITY_SUCCESS';
export const FETCH_INTERFACES_OF_ENTITY_FAILED = '[CHART_CONFIG] FETCH_INTERFACES_OF_ENTITY_FAILED';

export const FETCH_INTERFACES_OF_TERMINAL_REQUEST = '[CHART_CONFIG] FETCH_INTERFACES_OF_TERMINAL_REQUEST';
export const FETCH_INTERFACES_OF_TERMINAL_SUCCESS = '[CHART_CONFIG] FETCH_INTERFACES_OF_TERMINAL_SUCCESS';
export const FETCH_INTERFACES_OF_TERMINAL_FAILED = '[CHART_CONFIG] FETCH_INTERFACES_OF_TERMINAL_FAILED';

export const FETCH_UNITS_OF_CATEGORY_REQUEST = '[CHART_CONFIG] FETCH_UNITS_OF_CATEGORY_REQUEST';
export const FETCH_UNITS_OF_CATEGORY_SUCCESS = '[CHART_CONFIG] FETCH_UNITS_OF_CATEGORY_SUCCESS';
export const FETCH_UNITS_OF_CATEGORY_FAILED = '[CHART_CONFIG] FETCH_UNITS_OF_CATEGORY_FAILED';

export const LOAD_CHART_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_CHART_WIDGET_DATA_REQUEST";
